import { render, staticRenderFns } from "./CampoArchivo.vue?vue&type=template&id=f11c9702&scoped=true&"
import script from "./CampoArchivo.vue?vue&type=script&lang=js&"
export * from "./CampoArchivo.vue?vue&type=script&lang=js&"
import style0 from "./CampoArchivo.vue?vue&type=style&index=0&id=f11c9702&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11c9702",
  null
  
)

export default component.exports